import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface ICouponSectionProps {
  $type?: 'list' | 'card' | string;
  $bgColor?: string;
  $textColor?: string;
}

interface ICouponGroupProps {
  $bgColor?: string;
  $titleColor?: string;
}

export const CouponSection = styled.div<ICouponSectionProps>`
  padding: 32px 20px;
  text-align: center;
  background: #fff;

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }

    .basic-btn {
      color: #fff;
      border-color: #555;

      svg path {
        fill: #fff;
      }
    }
  }

  ${({ $bgColor, $textColor }) =>
    ($bgColor || $textColor) &&
    css`
      background-color: ${$bgColor};

      .basic-btn {
        color: ${$textColor};

        svg path {
          fill: ${$textColor};
        }
      }
    `}

  .section-title {
    padding-left: 0;
    padding-right: 0;
  }

  .text {
    text-align: left;
  }

  .coupon-wrap .group-title {
    text-align: center;
  }

  .basic-btn {
    margin-top: 20px;
    background: transparent;
  }

  .event-notice {
    padding-top: 20px;
  }

  ${props => {
    switch (props.$type) {
      case 'list':
        return css`
          .coupon-group {
            padding: 14px 22.5px;

            .group-title {
              margin-bottom: 10px;
            }

            .mega-coupon-item {
              margin: 0 auto;

              + .mega-coupon-item {
                margin-top: 6px;
              }
            }
          }
        `;
      case 'card':
        return css`
          .coupon-group {
            padding: 20px 22.5px;

            .group-title {
              margin-bottom: 14px;
            }

            .list {
              ${mixin.flex({
                align: 'center',
                justify: 'center',
                wrap: 'wrap',
              })}
              gap: 10px;
            }
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 20')};

    .basic-btn {
      margin-top: ${mixin.pxToVw('20')};
    }

    .event-notice {
      padding-top: ${mixin.pxToVw('20')};
    }

    ${props => {
      switch (props.$type) {
        case 'list':
          return css`
            .coupon-group {
              padding: ${mixin.pxToVw('14 22.5')};

              .group-title {
                margin-bottom: ${mixin.pxToVw('10')};
              }
            }
          `;
        case 'card':
          return css`
            .coupon-group {
              padding: ${mixin.pxToVw('20 22.5')};

              .group-title {
                margin-bottom: ${mixin.pxToVw('14')};
              }

              .list {
                gap: ${mixin.pxToVw('10')};
              }
            }
          `;
        default:
          return null;
      }
    }}
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    .coupon-wrap .group-title {
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 20px;
    }

    .basic-btn {
      width: 430px;
      height: 48px;
      margin-top: 48px;
    }

    .event-notice {
      padding-top: 30px;
    }

    ${props => {
      switch (props.$type) {
        case 'list':
          return css`
            .coupon-group {
              padding: 40px;

              .group-title {
                margin-bottom: 20px;
              }

              .list {
                ${mixin.flex({
                  align: 'center',
                  justify: 'center',
                  wrap: 'wrap',
                })}
                gap: 18px;

                .mega-coupon-item {
                  margin: 0;
                }
              }
            }
          `;
        case 'card':
          return css`
            .coupon-group {
              padding: 30px 150px;

              .list {
                gap: 20px;
              }
            }
          `;
        default:
          return null;
      }
    }}
  }
`;

export const CouponGroup = styled.div<ICouponGroupProps>`
  background: ${props => props.$bgColor};
  color: ${props => props.$titleColor};
`;
